import * as yup from "yup";

const useYup = schema => ((data, field, value) => {
  try {
    yup.object({value: schema}).validateSync({value}, { abortEarly: false });
  } 
  catch(error) {
    return error;
  }
});

export default useYup;